import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, message } from "antd"
import MarkItemError from '../../batches-mark-qc-v3/components/selectItemsQC/MarkItemError'
import { getDetailBarcode } from "../../../services/api/3dApi"

const MarkErrorItemPage = () => {
    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [errorInput, setErrorInput] = useState('')
    const [valueInput, setValueInput] = useState('')
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [item, setItem] = useState({})

    const { batchItem = {} } = Object.assign({}, item)
    const { _id: batch_item_id = '' } = Object.assign({}, batchItem)

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const handleShowModal = async (e) => {
        e.preventDefault()

        const check =/^#\d+_\d+$/.test(valueInput)

        if (check) {
            setValueInput(valueInput)
            const valueFormatted = valueInput.trim().replace(/^#/, '')

            if (!valueFormatted) {
                return null
            }

            _handleGetDataMark(valueFormatted)
        } else {
            setErrorInput('Item không đúng định dạng.')
        }
    }

    const _handleGetDataMark = async (value) => {
        setLoading(true)

        try {
            const { data: response } = await getDetailBarcode(value)

            const { data, success, error } = { ...response }
            if (!success) {
                return Modal.error({
                    title: 'Lỗi',
                    content: <div>{error}</div>,
                    onOk: _resetScanInput,
                    okText: 'Đóng',
                })
            }

            const { batchItem, status: orderStatus, production_status: orderProductionStatus } = Object.assign({}, data)
            const { error_at = '', status = '' } = Object.assign({}, batchItem)

            if (orderStatus === 'cancelled' || orderProductionStatus === 'cancelled') {
                return Modal.error({
                    title: 'Lỗi',
                    content: <div>Item {value} đã bị hủy.</div>,
                    onOk: _resetScanInput,
                    okText: 'Đóng',
                })
            }

            if (!batchItem) {
                return Modal.error({
                    title: 'Lỗi',
                    content: <div>Item {value} chưa được đẩy vào lô.</div>,
                    onOk: _resetScanInput,
                    okText: 'Đóng',
                })
            }

            if (!!error_at) {
                return Modal.error({
                    title: 'Lỗi',
                    content: <div>Item {value} đã được đánh dấu lỗi.</div>,
                    onOk: _resetScanInput,
                    okText: 'Đóng',
                })
            }

            if (status === "completed") {
                return Modal.error({
                    title: 'Lỗi',
                    content: <div>Item {value} đã hoàn thành.</div>,
                    onOk: _resetScanInput,
                    okText: 'Đóng',
                })
            }

            setItem(data)
            setIsOpenModal(true)

        } catch (e) {
            message.error(e.message)
        } finally {
            setLoading(false)
        }
    }

    const handleCancelModal = () => {
        setIsOpenModal(false)
    }

    return (
        <div className="site-layout-background pb-4">
            <div className="MarkErrorItemPage">
                <h1>Đánh dấu item QC lỗi</h1>
                <div className="position-relative">
                    <Spin spinning={loading} tip='Đang kiểm tra...'>
                        <form onSubmit={handleShowModal} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={_input}
                                autoFocus={true}
                                placeholder='Nhập item cần đánh dấu lỗi'
                                onChange={_handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={_resetScanInput}
                                />
                            }

                            {
                                loading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>
                    <MarkItemError
                        isOpen={isOpenModal}
                        id={!!batch_item_id ? batch_item_id : ''}
                        inputValue={valueInput}
                        reset={_resetScanInput}
                        onClose={handleCancelModal}
                    />
                </div>
            </div>
        </div>
    )
}

export default MarkErrorItemPage